import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../lib/utils";
import { cardDescriptionVariants } from "./styles";

export interface CardDescriptionProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const CardDescription = ({ className, ref, ...props }: CardDescriptionProps) => (
  <div ref={ref} data-slot="card-description" className={cn(cardDescriptionVariants(), className)} {...props} />
);
